import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import cookies from 'js-cookie'
import { Background, Modal, ModalContent, ModalClose } from '@mc/design-system'
import { withI18nContext } from '@mc/i18n'
import { useBucket } from '@mc/experiments-react'

import i18nInstance from '../i18n/i18nInstance'
import LoginForm from './LoginForm'
import RegisterForm from './RegisterForm'
import ResetPasswordForm from './ResetPasswordForm'
import ConfirmPasswordForm from './ConfirmPasswordForm'
import {
  LOGIN,
  REGISTER,
  RESET,
  CONFIRM,
  PROP_TYPES_VIEW,
  LOGIN_TITLE,
  REGISTER_TITLE,
  RESET_PASSWORD_TITLE,
  CONFIRM_PASSWORD_TITLE,
} from '../constants'

const AuthenticateModal = ({
  view,
  show,
  close,
  disableClose = false,
  nobackdrop = false,
  ...restProps
}) => {
  // Check if user is in variant_1 of the ce-3448-last-login-reminder experiment
  const lastLoginReminderBucket = useBucket('ce-3448-last-login-reminder')
  const isLastLoginReminderVariant1 = lastLoginReminderBucket === 'variant_1'

  // Apply mc-corners--lg for variant_1 users in applicable experiments
  const shouldApplyLargeCorners = isLastLoginReminderVariant1

  // used for BA testing
  const className = cn(
    'authentication-modal',
    { 'authentication-modal--login': view === LOGIN },
    { 'authentication-modal--register': view === REGISTER },
    { 'authentication-modal--reset': view === RESET },
    { 'authentication-modal--confirm': view === CONFIRM },
  )

  const contentAriaLabel = () => {
    switch (view) {
      case LOGIN:
        return LOGIN_TITLE
      case REGISTER:
        return REGISTER_TITLE
      case RESET:
        return RESET_PASSWORD_TITLE
      case CONFIRM:
        return CONFIRM_PASSWORD_TITLE
      default:
        return 'Authentication dialog'
    }
  }

  return (
    <Modal
      className={className}
      onClose={!disableClose && close}
      size='small'
      show
      nobackdrop={nobackdrop}
    >
      <ModalContent aria-label={contentAriaLabel()}>
        <Background
          color='light'
          className={cn('mc-invert', {
            'mc-corners--lg': shouldApplyLargeCorners,
          })}
        >
          {!disableClose && <ModalClose />}
          <div className='mc-px-4 mc-py-6'>
            {view === LOGIN && (
              <LoginForm
                onForgotPasswordClick={show(RESET)}
                onRegisterClick={show(REGISTER)}
                onConfirmationRequired={show(CONFIRM)}
                {...restProps}
              />
            )}

            {view === REGISTER && (
              <RegisterForm
                onLoginClick={show(LOGIN)}
                onConfirmationRequired={show(CONFIRM)}
                {...restProps}
              />
            )}

            {view === RESET && <ResetPasswordForm onLoginClick={show(LOGIN)} />}

            {view === CONFIRM && (
              <ConfirmPasswordForm
                auth={cookies.getJSON('needs_confirm_auth_hash')}
              />
            )}
          </div>
        </Background>
      </ModalContent>
    </Modal>
  )
}

AuthenticateModal.propTypes = {
  show: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  disableClose: PropTypes.bool,
  nobackdrop: PropTypes.bool,
  view: PROP_TYPES_VIEW.isRequired,
}

export default withI18nContext(i18nInstance)(AuthenticateModal)
